module.exports = __webpack_public_path__ + "img/25_37.ab3fae4e.png";